/**
 * The pre-namespacing key, shared by everyone who signed in on the browser. It is adopted once by the
 * first user to sign in after the upgrade and then removed, so the next person starts clean.
 */
export const USER_PREFERENCES_STORAGE_KEY = 'gr-user-preferences-v2';

/** Preferences are stored per user as `<prefix>:<cognito sub>`; signed-out state uses `anonymous`. */
export const USER_PREFERENCES_KEY_PREFIX = 'gr-user-preferences-v3';

export const ANONYMOUS_PREFERENCES_OWNER = 'anonymous';

export const USER_PREFERENCES_LEGACY_KEYS = {
  theme: 'gr-theme',
  dashboardLayoutV1: 'gr-dashboard-layout-v1',
  dashboardLayoutV2: 'gr-dashboard-layout-v2',
  dashboardLayoutV3: 'gr-user-preferences-v1.legacy',
  userPreferencesV1: 'gr-user-preferences-v1',
} as const;
